import { IFavoriteParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class RemoveFavoriteRequest extends Request<IFavoriteParams, IResult> {
  constructor(params: IFavoriteParams) {
    super('removeFavorite', params);
  }
}
